import HttpStatus from 'http-status-codes';

import type {HandleError} from '@pb/middleware-api';

enum ErrorReason {
    NOT_FOUND = 'NOT_FOUND',
}

type ErrorDto = {
    reason?: ErrorReason,
    message?: string,
};

const DEFAULT_ERROR_MESSAGE = 'We can\'t connect to the server at the moment. Please try again later, ' +
    'or contact a research associate for assistance.';

const createDefaultErrorDto = (): ErrorDto => {
    return {
        reason: ErrorReason.NOT_FOUND,
        message: 'Something went wrong',
    };
};

const checkResponseData = (data: unknown) => {
    if (typeof data === 'object' && data?.hasOwnProperty('reason')) {
        return data.hasOwnProperty('message') ? data : {...data, message: DEFAULT_ERROR_MESSAGE};
    } else {
        return createDefaultErrorDto();
    }
};

export const handleErrors: HandleError = params => {
    const {responseData, response} = params;
    const ok = response?.ok;

    if (response?.status === HttpStatus.UNAUTHORIZED) {
        window.location.reload();
    }

    if (!ok) {
        return Promise.reject(checkResponseData(responseData));
    }

    return Promise.resolve(responseData);
};
